/**
 * @generated SignedSource<<29295b28c92c7254a271e2068929e902>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type asanaItemsSingleAsanaBlockLinkQuery$variables = {
  id: string;
};
export type asanaItemsSingleAsanaBlockLinkQuery$data = {
  readonly node: {
    readonly asanablocklink?: {
      readonly externalId: string | null;
      readonly id: string;
      readonly project: {
        readonly externalId: string | null;
        readonly id: string;
        readonly name: string;
      };
    } | null;
    readonly blockId?: string;
    readonly blockKey?: string;
  } | null;
};
export type asanaItemsSingleAsanaBlockLinkQuery = {
  response: asanaItemsSingleAsanaBlockLinkQuery$data;
  variables: asanaItemsSingleAsanaBlockLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "blockId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "blockKey",
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AsanaBlockLinkNode",
      "kind": "LinkedField",
      "name": "asanablocklink",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AsanaProjectNode",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "NoteBlock",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "asanaItemsSingleAsanaBlockLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "asanaItemsSingleAsanaBlockLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9849770ee26dba49866647e518e1ca63",
    "id": null,
    "metadata": {},
    "name": "asanaItemsSingleAsanaBlockLinkQuery",
    "operationKind": "query",
    "text": "query asanaItemsSingleAsanaBlockLinkQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on NoteBlock {\n      blockId: id\n      blockKey: key\n      asanablocklink {\n        id\n        project {\n          id\n          name\n          externalId\n        }\n        externalId\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ba6f732463d5ca911dd21dcfb93389d";

export default node;
